import { PapiUser } from '@wix/da-types-papi';
import { createAction } from 'redux-actions';

export const requestJoinGroup = createAction(
  'GROUPS.REQUEST_JOIN',
  (group: PapiUser) => ({ group })
);
export const requestLeaveGroup = createAction(
  'GROUPS.REQUEST_LEAVE',
  (group: PapiUser) => ({ group })
);
export const groupJoinSuccess = createAction(
  'GROUPS.JOIN_SUCCESS',
  (group: PapiUser) => ({ group })
);
export const groupJoinFail = createAction(
  'GROUPS.JOIN_FAIL',
  (group: PapiUser, error: string) => ({ group, error })
);
export const groupJoinPending = createAction(
  'GROUPS.JOIN_PENDING',
  (group: PapiUser) => ({ group })
);
export const groupLeaveSuccess = createAction(
  'GROUPS.LEAVE_SUCCESS',
  (group: PapiUser) => ({ group })
);
export const groupLeaveFail = createAction(
  'GROUPS.LEAVE_FAIL',
  (group: PapiUser, error: string) => ({ group })
);
